var cutHour=(window.CB_CFG&&window.CB_CFG.cutHour!==undefined)?window.CB_CFG.cutHour:(11);
/* Panier interactif : mise à jour en place (sans rechargement complet). Après chaque
   changement, on re-récupère /cart rendu par le serveur et on remplace #cp-root — les
   prix, remises, barre de livraison et modes restent calculés côté serveur (zéro divergence). */
(function(){
  var BOLT='<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>';
  var JOURS=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  var cutoffTimer=null, attrCleaned=false, xsellHTML=null, lastIncart=null, busy=false;
  function pad(n){return n<10?'0'+n:''+n;}
  function hasBackorder(){return !!document.getElementById('cp-backorder-flag');}

  function initCountdown(){
    var el=document.getElementById('cp-cutoff');if(!el)return;
    if(cutoffTimer){clearInterval(cutoffTimer);cutoffTimer=null;}
    el.innerHTML=BOLT+(hasBackorder()?'<span>Articles sur commande : <strong>expédition sous 7 à 10 jours ouvrés</strong></span>':'<span>Commande <strong>expédiée sous 24 à 48 h</strong> (jours ouvrés)</span>');
    el.hidden=false;
  }

  function initShipmodes(){
    var wrap=document.querySelector('.cp-shipmodes');if(!wrap)return;
    function fmtFr(d){var j=['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];var m=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];return j[d.getDay()]+' '+d.getDate()+' '+m[d.getMonth()];}
    function addBiz(d,n){var r=new Date(d);while(n>0){r.setDate(r.getDate()+1);if(r.getDay()!==0&&r.getDay()!==6)n--;}return r;}
    var now=new Date();var bo=hasBackorder();var extra=bo?3:0;var ship;
    if(bo){ship=addBiz(now,7);} /* article sur commande : expédition sous 7 à 10 jours ouvrés */
    else{ship=new Date(now);ship.setDate(ship.getDate()+1); /* expédition sous 24 h ouvrées : dispatch au prochain jour ouvré */
    while(ship.getDay()===0||ship.getDay()===6){ship.setDate(ship.getDate()+1);}}
    wrap.querySelectorAll('.cp-shipmode__eta-dates').forEach(function(el){
      var mn=parseInt(el.getAttribute('data-min'),10),mx=parseInt(el.getAttribute('data-max'),10);
      el.textContent='entre '+fmtFr(addBiz(ship,mn))+' et '+fmtFr(addBiz(ship,mx+extra));
    });
    var modes=[].slice.call(wrap.querySelectorAll('.cp-shipmode'));
    modes.sort(function(a,b){return (parseInt(a.getAttribute('data-price'),10)||0)-(parseInt(b.getAttribute('data-price'),10)||0);});
    modes.forEach(function(m){wrap.appendChild(m);});
  }

  function initXsell(){
    var box=document.getElementById('cp-xsell');if(!box)return;
    var pid=box.getAttribute('data-pid');if(!pid)return;
    var grid=document.getElementById('cp-xsell-grid');if(!grid)return;
    var incart=box.getAttribute('data-incart')||'';
    function attachAdd(){
      grid.querySelectorAll('button.cp-xs__add').forEach(function(b){
        if(b.__w)return;b.__w=1;
        b.addEventListener('click',function(){
          if(busy)return;
          var vid=parseInt(b.getAttribute('data-vid'),10);var sp=b.querySelector('span');var o=sp.textContent;b.disabled=true;sp.textContent='...';
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})}).then(function(r){return r.json();}).then(function(){lastIncart=null;cpReload();}).catch(function(){sp.textContent=o;b.disabled=false;});
        });
      });
    }
    function show(html){grid.innerHTML=html;box.hidden=false;attachAdd();}
    if(incart===lastIncart&&xsellHTML){show(xsellHTML);return;}
    lastIncart=incart;
    function load(intent,cb){
      fetch('/recommendations/products?section_id=cart-cross-sell&product_id='+pid+'&intent='+intent+'&limit=10').then(function(r){return r.text();}).then(function(html){
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var g=tmp.querySelector('.cp-xsell__grid');
        if(g&&g.children.length){xsellHTML=g.innerHTML;show(xsellHTML);}
        else if(cb){cb();}
      }).catch(function(){if(cb)cb();});
    }
    load('complementary',function(){load('related');});
  }

  /* Nettoyage des anciens attributs de panier « Réapprovisionnement » / « Préférence de livraison » (fonction retirée le 15/09/2026) */
  function cleanAttrs(){
    if(attrCleaned||!document.getElementById('cp-attr-clean'))return;
    attrCleaned=true;
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Réapprovisionnement':'','Préférence de livraison':''}})}).catch(function(){});
  }

  function initAll(){initCountdown();initShipmodes();cleanAttrs();initXsell();}

  function cpReload(){
    var root=document.getElementById('cp-root');if(!root){window.location.reload();return;}
    root.classList.add('is-loading');
    fetch('/cart',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.getElementById('cp-root');
      if(!fresh){window.location.reload();return;}
      root.innerHTML=fresh.innerHTML;
      root.classList.remove('is-loading');
      busy=false;
      var c=doc.querySelector('.sk-cart-count');
      if(c){document.querySelectorAll('.sk-cart-count,#sk-cd-count').forEach(function(el){el.textContent=c.textContent.trim();});}
      initAll();
    }).catch(function(){window.location.reload();});
  }
  window.cpReload=cpReload;

  window.cpQty=function(key,qty){
    if(qty<0||busy)return;
    busy=true;
    var root=document.getElementById('cp-root');if(root)root.classList.add('is-loading');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(function(){cpReload();})
      .catch(function(){busy=false;window.location.reload();});
  };
  window.cpRemove=function(key){window.cpQty(key,0);};

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
})();
